export default "__VITE_ASSET__MIMQX3T___"